import { useContext, useEffect, useRef, useState } from 'react';
import { ReactComponent as FaultSvg } from './icons/fault.svg'
import { ReactComponent as NormalSvg } from './icons/normal.svg'
import { ReactComponent as MaintenanceSvg } from './icons/maintenance.svg'
import './index.less'
import fakeData from './fakeData_device_status.json';

interface Iprops {
}
const TabType = {
    All: 'All',
    Normal: 'Normal',
    Fault: 'Fault',
    Maintenance: 'Maintenance',
};

export default function DeviceStatusPanel(props: Iprops) {
    const [inspectData, setInspectData] = useState(fakeData); // 假数据作为初始化数据
    const [selectedItems, setSelectedItems] = useState([]); // 保存选中的项
    const [activeTab, setActiveTab] = useState(TabType.All); // 当前选中的页签

    useEffect(() => {
        // 模拟从后端获取数据
        setTimeout(() => {
            setInspectData(fakeData);
        }, 100);
    }, []);

    // 计算状态的数量
    const inspectCount = inspectData.filter(item => item.status === '正常').length;
    const faultCount = inspectData.filter(item => item.status === '故障').length;
    const maintenanceCount = inspectData.filter(item => item.status === '维修中').length;

    // 点击记录时的处理逻辑
    const handleRecordClick = (item, event) => {
        if (event.ctrlKey) {
            // Ctrl 被按下时多选
            setSelectedItems(prev =>
                prev.includes(item)
                    ? prev.filter(i => i !== item) // 如果已经选中，取消选中
                    : [...prev, item] // 否则添加到选中的列表
            );
        } else {
            // 单选：如果已经选中，则取消；否则只选中当前项
            setSelectedItems(prev =>
                prev.includes(item) ? [] : [item]
            );
        }
    };

    const isSelected = (item) => selectedItems.includes(item);

    // 根据当前选中的页签过滤数据
    const filteredData = inspectData.filter(item => {
        if (activeTab === TabType.Normal) return item.status === '正常';
        if (activeTab === TabType.Fault) return item.status === '故障';
        if (activeTab === TabType.Maintenance) return item.status === '维修中';
        return true; // 'All' 选项时返回所有数据
    });

    // 根据状态选择图标
    const getStatusIcon = (status) => {
        let statusText;
        let statusClass;

        if (status === '正常') {
            statusText = '正常';
            statusClass = 'status-text normal';
            return (
                <div className="status-wrapper">
                    <NormalSvg className='status-icon' />
                    <span className={statusClass}>{statusText}</span>
                </div>
            );
        }
        if (status === '故障') {
            statusText = '故障';
            statusClass = 'status-text fault';
            return (
                <div className="status-wrapper">
                    <FaultSvg className='status-icon' />
                    <span className={statusClass}>{statusText}</span>
                </div>
            );
        }
        if (status === '维修中') {
            statusText = '维修中';
            statusClass = 'status-text maintenance';
            return (
                <div className="status-wrapper">
                    <MaintenanceSvg className='status-icon' />
                    <span className={statusClass}>{statusText}</span>
                </div>
            );
        }
        return null;
    };

    return (
        <div className="inspect-panel">
            <div className="inspect-header">
                <div className="inspect-title">设备状态</div>
            </div>

            <div className="inspect-counts">
                <div className="count-item">
                    <div className="count-label">正常</div>
                    <div className="count-number-container">
                        <div className="count-number" style={{ color: '#56B11E' }}>{inspectCount}</div>
                        <span className="count-unit">个</span></div>
                </div>
                <div className="vertical-separator state"></div>
                <div className="count-item">
                    <div className="count-label">故障</div>
                    <div className="count-number-container">
                        <div className="count-number" style={{ color: '#CE0000' }}>{faultCount}</div>
                        <span className="count-unit">个</span></div>
                </div>
                <div className="vertical-separator state"></div>
                <div className="count-item">
                    <div className="count-label">维修中</div>
                    <div className="count-number-container ">
                        <div className="count-number" style={{ color: '#EE8F00' }}>{maintenanceCount}</div>
                        <span className="count-unit">个</span></div>
                </div>
            </div>
            <div className="top-tab">
                <div className={activeTab === TabType.All ? 'tab-item active' : 'tab-item'} onClick={() => setActiveTab(TabType.All)}>全部</div>
                <div className={activeTab === TabType.Normal ? 'tab-item active' : 'tab-item'} onClick={() => setActiveTab(TabType.Normal)}>正常</div>
                <div className={activeTab === TabType.Fault ? 'tab-item active' : 'tab-item'} onClick={() => setActiveTab(TabType.Fault)}>故障</div>
                <div className={activeTab === TabType.Maintenance ? 'tab-item active' : 'tab-item'} onClick={() => setActiveTab(TabType.Maintenance)}>维修中</div>
            </div>
            <div className="inspect-list">
                {filteredData.length > 0 ? (
                    filteredData.map((item, index) => (
                        <div
                            key={index}
                            className={`inspect-records ${isSelected(item) ? 'selected' : ''}`} // 添加选中样式
                            onClick={(event) => handleRecordClick(item, event)} // 点击处理
                        >
                            <div className="record-left">
                                <div className="record-date">{item.date}</div>
                                <div className="record-name">{item.name}</div>
                            </div>
                            <div className="record-right">
                                {getStatusIcon(item.status)}  {/* 显示状态图标和文本 */}
                            </div>
                        </div>
                    ))
                ) : (
                    <div className="no-list">暂无记录</div>
                )}
            </div>
        </div>
    );
}